import { Salutation } from "@/shared/generated";

// The variable Unknown is not used, but must be specified to build the ValidSalutation enum.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { Unknown, ...ValidSalutation } = Salutation;

export { ValidSalutation };
